import React, { useState } from 'react';
import "../components/Form.css"

function Form() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Perform any action you want with the form data, e.g., send it to a server
    console.log('Form submitted:', formData);
  };

  return (
    <div className='form'>
        <div className='formContent'>
          <h1>Want to know more about our company?</h1>
      <form onSubmit={handleSubmit}>
        <label>
          <input
            type='text'
            name='name'
            placeholder='name'
            value={formData.name}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          <input
            type='email'
            name='email'
            placeholder='e-mail'
            value={formData.email}
            onChange={handleChange}
          />
        </label>
        <br />
        <button type='submit'>Submit</button>
      </form>
    </div>      
    </div>
  );
}

export default Form;
